import React, { useState, useEffect } from 'react';
import { apiFetchOrThrow } from '../../auth/apiFetch';
import { fmtDateTimeUS } from '../../utils/dates';
export default function PendingWithdrawalsTab() {
  const [withdrawals, setWithdrawals] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [confirmingId, setConfirmingId] = useState(null);
  const token = localStorage.getItem('token');

  useEffect(() => {
    const fetchPending = async () => {
      try {
        setLoading(true);
        const resp = await fetch('/api/withdrawals/pending/', {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
          },
        });
        if (!resp.ok) throw new Error('Error loading pending-requests');
        const data = await resp.json();
        setWithdrawals(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    fetchPending();
  }, [token]);

  const handleConfirm = async (id) => {
    if (!window.confirm(`Confirm withdrawal #${id}?`)) return;
    try {
      setConfirmingId(id);
      const resp = await fetch(`/api/withdrawals/${id}/confirm/`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
      });
      if (!resp.ok) throw new Error('Error confirming request');
      setWithdrawals(ws => ws.filter(w => w.id !== id));
    } catch (err) {
      alert(err.message);
    } finally {
      setConfirmingId(null);
    }
  };

  return (
    <div className="bg-white p-6 rounded shadow overflow-x-auto">
      <h3 className="text-2xl font-semibold mb-4">Pending Withdrawals</h3>

      {loading ? (
        <p>Loading…</p>
      ) : error ? (
        <p className="text-red-500">{error}</p>
      ) : (
        <table className="min-w-full text-sm">
          <thead className="border-b bg-gray-50">
            <tr>
              <th className="px-4 py-2 text-left">ID</th>
              <th className="px-4 py-2 text-left">User</th>
              <th className="px-4 py-2 text-right">Amount</th>
              <th className="px-4 py-2 text-left">Phone</th>
              <th className="px-4 py-2 text-left">Email</th>
              <th className="px-4 py-2 text-left">Created At</th>
              <th className="px-4 py-2 text-center">Action</th>
            </tr>
          </thead>
          <tbody>
            {withdrawals.map(w => {
              // распарсим payment_details
              let phone = '';
              let payEmail = '';
              try {
                const details = JSON.parse(w.payment_details || '{}');
                phone = details.phone || '';
                payEmail = details.email || '';
              } catch (_) {}
              return (
                <tr key={w.id} className="border-b hover:bg-gray-100">
                  <td className="px-4 py-2">{w.id}</td>
                  <td className="px-4 py-2">{w.user_email}</td>
                  <td className="px-4 py-2 text-right">${parseFloat(w.amount).toFixed(2)}</td>
                  <td className="px-4 py-2">{phone}</td>
                  <td className="px-4 py-2">{payEmail}</td>
                  <td className="px-4 py-2">{fmtDateTimeUS(w.created_at)}</td>
                  <td className="px-4 py-2 text-center">
                    <button
                      onClick={() => handleConfirm(w.id)}
                      disabled={confirmingId === w.id}
                      className="bg-green-600 text-white px-3 py-1 rounded hover:bg-green-700 transition text-sm disabled:opacity-50"
                    >
                      {confirmingId === w.id ? 'Confirming…' : 'Confirm'}
                    </button>
                  </td>
                </tr>
              );
            })}

            {withdrawals.length === 0 && (
              <tr>
                <td colSpan="7" className="py-4 text-center text-gray-500">
                  No penging requests
                </td>
              </tr>
            )}
          </tbody>
        </table>
      )}
    </div>
  );
}
